import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, isPublicRoute } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute check:', {
    path: location.pathname,
    isAuthenticated,
    isLoading,
    isPublicRoute
  });

  // Allow access to public routes without authentication
  if (isPublicRoute) {
    console.log('Public route access granted:', location.pathname);
    return children;
  }

  // Show loading state for authenticated routes
  if (isLoading) {
    console.log('Auth loading for route:', location.pathname);
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('Auth required, redirecting to login from:', location.pathname);
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // User is authenticated, render children
  console.log('Authentication verified, rendering route:', location.pathname);
  return children;
}